/*!
 * jQuery Extensions Library.
 *
 * Copyright (C) HaiKom AB 2007-2014
 */

; (function ($) {
	'use strict';

	if (!$.showCookieInformation) {
		$.extend({
			showCookieInformation: function (element, options) {
				var self = $(element);

				var cookieSetDataName = 'cookie-message-set';
				var cookieName = 'cookie-message-closed';

				var opts = $.extend({
					cookieExpiryDays: 182, // ~ 6 months
					cookiePath: '/'
				}, options);

				if (!opts.message ||
					(typeof opts.message === 'string' && opts.message.trim() === '')) {
					console.warn('A message is missing, skipping initialization of showCookieInformation plugin');
					return;
				}

				var cookieMessageSet = self.data(cookieSetDataName);
				if (cookieMessageSet) {
					return;
				}

				var setCookieMessageClosed = function () {
					var date;
					if (opts.expirationdays > 0) {
						date = new Date();
						date.setTime(date.getTime() + (opts.expirationdays * 24 * 60 * 60 * 1000));
					}

					docCookies.setItem(cookieName, true, date, opts.cookiePath);
				};

				var showMessage = function (parent) {
					var setContainerHeight = function (container) {
						container.css('height', $('.cookie-info', container).outerHeight(true));
					};

					var hasCloseButton = opts.message.includes('close-button');

					var infoContainer = $('<div class="cookie-info-container">' +
						'<div class="cookie-info">' +
						//'<i class="fa fa-info-circle" aria-hidden="true"></i>&nbsp;' +
						'<span class="message">' + opts.message + '</span>' +
						(opts.informationPageUrl ? '&nbsp;<a class="information-page-link" href="' + opts.informationPageUrl + '">' + opts.informationPageText + '</a>' : '') +
						(hasCloseButton ? '' : '<div class="close-button-container"><a class="close-button" href="">&times;</a></div>') +
						'</div>&nbsp;' +
						'</div>');
					infoContainer.appendTo(parent);
					setContainerHeight(infoContainer);

					$('a.close-button', infoContainer).click(function (e) {
						setCookieMessageClosed();

						infoContainer.slideUp(250, function () {
							infoContainer.remove();
						});

						e.preventDefault();
					});

					$(window).resize(function (e) {
						setContainerHeight(infoContainer);
					});
				};

				var cookie = docCookies.getItem(cookieName);
				if (cookie !== 'true') {
					showMessage(self);
				}

				self.data(cookieSetDataName, true);
			}
		});
		$.fn.extend({
			showCookieInformation: function (options) {
				return $.showCookieInformation($(this), options);
			}
		});
	}

	if (!$.flexHeight) {
		$.extend({
			flexHeight: function (element, options) {
				var self = $(element);
				var tagName = self.prop('tagName').toLowerCase();
				if (tagName !== 'textarea') {
					console.warn('Flex height does not support elements of type ' + tagName + '.');
					return;
				}

				var initialized = self.data('flex-height-initialized');
				if (initialized) {
					console.warn('Tried to initialize flex height on an element that already has the plugin.', tagName, self.attr('id') || self.attr('name') || '');
					return;
				}

				self.wrap('<div class="flex-height-wrapper" />')
					.before('<span class="pre"><span class="mirror" /><br /></span>');

				var wrapper = self.parent();
				wrapper.addClass(self.attr('class'));
				if (self.is('[disabled]')) {
					wrapper.attr('disabled', self.attr('disabled'));
				}
				if (self.is('[readonly]')) {
					wrapper.attr('readonly', self.attr('readonly'));
				}

				var span = wrapper.find('span.mirror');

				self.on('input propertychange keyup change', function () {
					_mirror();
				});

				var minHeight = _calculateWrapperMinHeight();
				if (minHeight) {
					wrapper.css('min-height', minHeight);
					wrapper.find('span.pre').css('min-height', minHeight);
					self.css('min-height', minHeight);
				}

				// Note:
				// According to http://api.jquery.com/val/, using .val() on <textarea> elements strips carriage return characters from the browser-reported value.
				// This is a workaround using a valHook, reported in the link above.
				$.valHooks.textarea = {
					get: function (elem) {
						return elem.value.replace(/\r?\n/g, "\r\n");
					}
				};

				_mirror();

				self.data('flex-height-initialized', true);

				function _mirror() {
					span.text(self.val());
				}

				function _num(value) {
					return parseInt(value, 10) || 0;
				}

				function _calculateWrapperMinHeight() {
					var result = 0;

					var lines = Math.max(_num(self.attr('rows')), 2);

					var wrapperClone = wrapper.clone();
					wrapperClone.css('margin', 0)
						.css('visibility', 'hidden');
					var spanClone = wrapperClone.find('span.mirror');
					spanClone.text('\n'.repeat(lines - 1));
					wrapperClone.appendTo('body');

					result = wrapperClone.outerHeight();

					wrapperClone.remove();

					return result;
				}
			}
		});

		$.fn.extend({
			flexHeight: function (options) {
				return $.flexHeight($(this), options);
			}
		});
	}

	if (!$.templateQuantitySelection) {
		$.extend({
			templateQuantitySelection: function (element, options) {
				var self = $(element);
				var initialized = self.data('template-quantity-selection-initialized');
				if (initialized) {
					var tagName = self.prop('tagName').toLowerCase();
					console.warn('Tried to initialize template quantity selection on an element that already has the plugin.', tagName, self.attr('id') || self.attr('name') || '');
					return;
				}

				options = $.extend({
					textBox: null,
					dropDown: null,
					onChange: null,
					templateId: null,
					triggerChangeOnLoad: false,
					timeout: 400
				}, options);
				var callbackTimeout;

				if (typeof options.textBox === 'string') {
					options.textBox = $(options.textBox);
				}
				if (typeof options.dropDown === 'string') {
					options.dropDown = $(options.dropDown);
				}
				if (options.timeout < 0) {
					options.timeout = 0;
				}

				function dispatchOnChangedCallback() {
					var quantity = 0;
					if (options.textBox &&
						options.textBox.is(':visible')) {
						quantity = parseFloat(options.textBox.val());
					} else if (options.dropDown &&
						options.dropDown.is(':visible')) {
						quantity = parseFloat(options.dropDown.val());
					}

					if (quantity > 0) {
						self.trigger('tqs:quantitychanged', [{ 'templateId': options.templateId, 'quantity': quantity }]);

						if (options.onChange) {
							var onChangeCallback = null;
							if (typeof options.onChange === 'function') {
								onChangeCallback = options.onChange;
							} else if (typeof window[options.onChange] === 'function') {
								onChangeCallback = window[options.onChange];
							}
							if (onChangeCallback) {
								onChangeCallback(quantity);
							}
						}
					}
				}

				function dispatchOnChanged() {
					if (callbackTimeout) {
						clearTimeout(callbackTimeout);
					}

					callbackTimeout = setTimeout(dispatchOnChangedCallback, options.timeout);
				}

				if (options.textBox) {
					options.textBox.change(function () {
						dispatchOnChanged();
					});
				}

				if (options.dropDown) {
					options.dropDown.change(function () {
						dispatchOnChanged();
					});
				}

				if (typeof options.triggerChangeOnLoad === 'string') {
					options.triggerChangeOnLoad = (options.triggerChangeOnLoad.toLowerCase() === 'true');
				}

				if (options.triggerChangeOnLoad === true) {
					dispatchOnChanged();
				}

				self.data('template-quantity-selection-initialized', true);
			}
		});
		$.fn.extend({
			templateQuantitySelection: function (options) {
				return $.templateQuantitySelection($(this), options);
			}
		});
	}

	if (!$.templateQuantitySelectionListener) {
		$.extend({
			templateQuantitySelectionListener: function (element, options) {
				var self = $(element);
				var initialized = self.data('template-quantity-selection-listener-initialized');
				if (initialized) {
					var tagName = self.prop('tagName').toLowerCase();
					console.warn('Tried to initialize template quantity selection listener on an element that already has the plugin.', tagName, self.attr('id') || self.attr('name') || '');
					return;
				}

				options = $.extend({
					portal: null,
					customer: null,
					mediaObjectId: null,
					templateId: null,
					shoppingCartId: null,
					templateQuantitySelection: null,
					priceContainer: null,
					apiUrl: null,
					languageCode: null
				}, options);

				if (typeof options.templateQuantitySelection === 'string') {
					options.templateQuantitySelection = $(options.templateQuantitySelection);
				}
				if (typeof options.priceContainer === 'string') {
					options.priceContainer = $(options.priceContainer);
				}

				if (options.templateQuantitySelection) {
					options.templateQuantitySelection.on('tqs:quantitychanged', function (e, data) {
						// if(options.templateId !== data.templateId) {
						//   console.warn('The template IDs does not match', options.templateId, data.templateId);
						//   return;
						// }

						$.ajax({
							type: 'get',
							data: {
								portal: options.portal,
								customer: options.customer,
								mediaObject: options.mediaObjectId,
								template: data.templateId,
								quantity: data.quantity,
								shoppingCart: options.shoppingCartId,
								languageCode: options.languageCode
							},
							url: options.apiUrl,
							success: function (responseString) {
								var response = responseString.toJSON();
								var titleTooltip = '';
								var errorMessage = $('.error.message', options.priceContainer);

								if (response.ErrorMessage &&
									response.ErrorMessage !== '') {
									titleTooltip = response.ErrorMessage || '';
									errorMessage.removeClass('hide')
										.html(hk.message('Unable to retrieve price information'));
								} else {
									titleTooltip = response.PriceDetails || '';
									errorMessage.addClass('hide')
										.html('');
								}

								options.priceContainer.attr('title', titleTooltip);
								$('.price-text', options.priceContainer).html(response.PriceString || '');
								$('.quantity-text', options.priceContainer).html(response.QuantityString || '');
								$('.vat-text', options.priceContainer).html(response.VatString || '');
								$('.other-estimated-currency-text', options.priceContainer).html(response.OtherEstimatedCurrencyString || '');
							}
						});
					});
				}

				self.data('template-quantity-selection-listener-initialized', true);
			}
		});
		$.fn.extend({
			templateQuantitySelectionListener: function (options) {
				return $.templateQuantitySelectionListener($(this), options);
			}
		});
	}

	if (!$.initFoundationPlugins) {
		$.extend({
			initFoundationPlugins: function (elements) {
				if (elements instanceof jQuery) {
					elements = elements.toArray();
				} else if (typeof elements === 'string') {
					elements = [elements];
				} else if (!(elements instanceof Array)) {
					elements = [];
				}

				var getPluginsParentPluginElement = function (element) {
					if (!element || element.length === 0) {
						return null;
					} else if (typeof element === 'string') {
						element = $(element);
					}

					try {
						var zfp = element.data('zfPlugin');

						if (zfp) {
							return element;
						} else {
							return getPluginsParentPluginElement(element.parent());
						}
					} catch (ex) {
						console.warn(ex.message);

						return null;
					}
				};

				elements.forEach(function (element) {
					try {
						if (typeof element === 'string') {
							element = $(element);
						}
						if (!(element instanceof jQuery)) {
							element = $(element);
						}

						var zfpParentPluginElement = getPluginsParentPluginElement(element);

						if (!zfpParentPluginElement) {
							element.foundation();
						}
					} catch (ex) {
						console.warn(ex.message);
					}
				});
			}
		});
	}

	if (!$.fn.hitch) {
		// Hitch function from http://think-robot.com/2009/06/hitch-object-oriented-event-handlers-with-jquery/
		$.fn.hitch = function (ev, fn, scope) {
			return this.bind(ev, function () {
				return fn.apply(scope || this, Array.prototype.slice.call(arguments));
			});
		};
	}

	if (!$.preLoadImages) {
		// Defines a jQuery pre-load image plug-in.
		var cache = [];
		$.extend({
			preLoadImages: function () {
				// Arguments are image paths relative to the current page.
				var argsLength = arguments.length,
					cacheImage;
				for (var i = 0; i < argsLength; i++) {
					cacheImage = document.createElement('img');
					cacheImage.src = arguments[i];
					cache.push(cacheImage);
				}
			}
		});
	}

	// Defines a jQuery enable plug-in.
	if (!$.enable) {
		$.extend({
			enable: function (element) {
				if (typeof element === 'undefined') {
					return false;
				} else if (typeof element !== 'object') {
					element = $(element);
				}
				return element.prop('disabled', false).removeAttr('disabled').removeClass('aspNetDisabled');
			}
		});
		$.fn.extend({
			enable: function () {
				return $.enable($(this));
			}
		});
	}

	// Defines a jQuery disable plug-in.
	if (!$.disable) {
		$.extend({
			disable: function (element) {
				if (typeof element === 'undefined') {
					return false;
				} else if (typeof element !== 'object') {
					element = $(element);
				}
				return element.prop('disabled', true).attr('disabled', 'disabled').addClass('aspNetDisabled');
			}
		});
		$.fn.extend({
			disable: function () {
				return $.disable($(this));
			}
		});
	}

	// Defines a jQuery exists plug-in.
	if (!$.exists) {
		$.extend({
			exists: function (element) {
				if (typeof element === 'undefined') {
					return false;
				} else if (typeof element !== 'object') {
					element = $(element);
				}
				return element.length > 0;
			}
		});

		$.fn.exists = function (selector) {
			if (selector) {
				return $.exists($(this).find(selector));
			} else {
				return $.exists($(this));
			}
		};
	}

	// Defines a jQuery popup plug-in.
	if (!$.openPopup) {
		$.extend({
			openPopup: function (url, options) {
				var warningMessageControlId = 'popup-blocked-warning-message';
				var defaultPopupBlockedWarningMessage = 'It seems like your browser has prevented this site from opening a pop-up window, please allow pop-up windows for this site in order to make it work properly.';
				options = $.extend({
					target: '',
					features: '',
					replace: false,
					popupBlockedWarningMessage: defaultPopupBlockedWarningMessage
				}, options);

				var popup = window.open(url, options.target, options.features, options.replace);

				var displayWarning = function () {
					console.warn(defaultPopupBlockedWarningMessage);

					if (typeof options.popupBlockedWarningMessage === 'string') {
						var message = hk.message(options.popupBlockedWarningMessage.trim());
						if (message !== '') {
							var base = $('#base');

							var setContainerHeight = function (container) {
								container.css('height', $('.system-alert', container).outerHeight(true));
							};

							var alertContainer = $('#' + warningMessageControlId, base);
							if ($.exists(alertContainer)) {
								alertContainer.remove();
							}

							alertContainer = $('<div id="' + warningMessageControlId + '" class="system-alert-container">' +
								'<div class="system-alert">' +
								'<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>&nbsp;' +
								'<span class="message">' + message + '</span>' +
								'<div class="close-button-container">' +
								'<a class="close-button" href="">&times;</a>' +
								'</div>' +
								'</div>&nbsp;' +
								'</div>');
							alertContainer.prependTo(base);
							setContainerHeight(alertContainer);

							$('a.close-button', alertContainer).click(function (e) {
								alertContainer.slideUp(250, function () {
									alertContainer.remove();
								});

								e.preventDefault();
							});

							$(window).resize(function (e) {
								setContainerHeight(alertContainer);
							});
						}
					}
				};

				var detectPopupBlocked = function () {
					if (!popup || typeof (popup.close) === 'undefined' || parseInt(popup.innerWidth) === 0) {
						displayWarning();
					}
				};

				setTimeout(detectPopupBlocked, 250);
			}
		});
	}

	// Defines a jQuery toggler plug-in.
	if (!$.toggler) {
		$.extend({
			toggler: function (trigger, target, options) {
				if (typeof trigger === 'undefined') {
					console.error('Trigger is undefined');
					return;
				} else if (typeof target === 'undefined') {
					console.error('Target is undefined');
					return;
				}
				if (typeof trigger !== 'object') {
					trigger = $(trigger);
				}
				if (!trigger.length) {
					console.error('Trigger not specified');
					return;
				}
				if (typeof target !== 'object') {
					target = $(target);
				}
				if (!target.length) {
					console.error('Target not specified');
					return;
				}

				var opts = $.extend({
					toggleClass: ''
				}, options);

				trigger.click(function (e) {
					var toggleClass = opts.toggleClass;

					var togglerOptions = target.data('toggler-options');
					if (togglerOptions &&
						togglerOptions.class) {
						toggleClass = togglerOptions.class;
					}

					target.toggleClass(toggleClass);

					e.preventDefault();
				});
			}
		});
		$.fn.extend({
			toggler: function (target, options) {
				return $.toggler($(this), target, options);
			}
		});
	}

	if (!$.toggleShowHide) {
		$.extend({
			toggleShowHide: function (trigger, target, options) {
				if (typeof trigger === 'undefined') {
					console.error('Trigger is undefined');
					return;
				} else if (typeof target === 'undefined') {
					console.error('Target is undefined');
					return;
				}
				if (typeof trigger !== 'object') {
					trigger = $(trigger);
				}
				if (!trigger.length) {
					console.error('Trigger not specified');
					return;
				}
				if (typeof target !== 'object') {
					target = $(target);
				}
				if (!target.length) {
					console.error('Target not specified');
					return;
				}

				var toggleClass = 'hide';
				var opts = $.extend({
					onShown: function (trigger, target) { },
					onHidden: function (trigger, target) { }
				}, options);

				var targetVisible = false,
					targetHovered = false;
				trigger.click(function (e) {
					target.toggleClass(toggleClass);

					if (!target.hasClass(toggleClass)) {
						if (typeof opts.onShown === 'function') {
							opts.onShown(trigger, target);
						}

						targetVisible = true;
					} else {
						if (typeof opts.onHidden === 'function') {
							opts.onHidden(trigger, target);
						}

						targetVisible = false;
					}

					e.preventDefault();
					e.stopPropagation();
				});

				// Keep track of mouseover/mouseout status of target
				target.mouseenter(function () {
					targetHovered = true;
				}).mouseleave(function () {
					targetHovered = false;
				});

				// Click trigger when clicking outside of visible target
				$('html').click(function () {
					if (targetVisible && !targetHovered) {
						trigger.click();
					}
				});
			}
		});
		$.fn.extend({
			toggleShowHide: function (target, options) {
				return $.toggleShowHide($(this), target, options);
			}
		});
	}

	if (!$.cssPositions) {
		$.extend({
			cssPositions: function (control, prefix) {
				return {
					top: parseFloat(control.css((prefix ? prefix + '-' : '') + 'top')),
					bottom: parseFloat(control.css((prefix ? prefix + '-' : '') + 'bottom')),
					left: parseFloat(control.css((prefix ? prefix + '-' : '') + 'left')),
					right: parseFloat(control.css((prefix ? prefix + '-' : '') + 'right'))
				};
			}
		});
		$.fn.extend({
			cssPositions: function (prefix) {
				return $.cssPositions($(this), prefix);
			}
		});
	}
})(jQuery);
